<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          name="ez_drm-username"
          label="Username*"
          label-position="top"
        >
          <div>
            {{ settings.username }}
          </div>
        </input-field>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          name="ez_drm-password"
          label="Password*"
          label-position="top"
        >
          <span
            v-clipboard:copy="settings.password"
            v-clipboard:success="copySuccess"
            class="position-relative link cursor-pointer"
          >
            {{ settings.password }}

            <span
              v-if="!showPassword"
              class="position-absolute keyPlaceholder text-nowrap overflow-hidden "
            >
              {{ dots }}
            </span>
          </span>
          <GjIcon
            name="Copy"
            size="20"
            class="link cursor-pointer"
          />
          <b-button
            variant="bg-white"
            class="toggleShowKey ml-1 text-xsm"
            @click="showPassword = !showPassword"
          >
            {{ showPassword ? 'Hide' : 'Show' }}
          </b-button>
        </input-field>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import InputField from '@/components/form/InputField.vue'

export default {
  name: 'EzDrm',
  components: {
    InputField,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPassword: false,
      dots:
        '•••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••',
    }
  },
}
</script>

<style>
button.btn.toggleShowKey {
  height: 26px !important;
  padding: 0 9px;
}
.keyPlaceholder {
  right: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: white;
  width: 100%;
}
</style>
